// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3A589","content":"GlobalSearch_content__QGegM"};